// extracted by mini-css-extract-plugin
module.exports = {"flex":"Advantages_flex__3WzgY","flexItem":"Advantages_flexItem__1Y9AU","title":"Advantages_title__1SfGs"};